import { useQuery } from '@tanstack/react-query';
import { useForBindingId } from '../../../forBinding';
import api from '../../http';

export function useGetAdviceCorrectionById(id: string, options?: { enabled?: boolean }) {
	const forBinding = useForBindingId();
	return useQuery({
		queryKey: ['correction', id, forBinding],
		enabled: (options?.enabled ?? true) && !!id,
		queryFn: async () => {
			const { data } = await api.get<any>(`/advices/planting/get/${id}`, {
				params: { forBinding },
			});
			return data;
		},
	});
}
